import styled from 'styled-components';

//modal
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { RiCloseFill } from 'react-icons/ri';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
//chackbox
import Checkbox from '@mui/material/Checkbox';
import { green } from '@mui/material/colors';
import ProductTable from './molecules/ProductTable';

export const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})(props => <Checkbox color='default' {...props} />);

export const ProductomodalContainer = styled.div`
  display: grid;
  gap: 1rem;
  grid-auto-rows: auto;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
`;

export const ProductomodalColumna = styled.div`
  display: flex;
  flex-direction: row;
`;
export const BarcodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size:50%;
`;

export const ProductoContainer = styled.div`
  display: flex;
  position: absolute;
  top: 3.5rem;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  align-items: center;
`;

export const ProductoFiltroContainer = styled.div`
  display: flex;
  gap: 3rem;
  margin: 10px;
`;

export const StyledTable = styled(ProductTable)`
  width: 100%;
`;

export const BotonesTabla = styled.div`
  display: flex;
  flex-direction: row;
  margin: 4px;
  padding: 4px;
`;

export const StyledFloatingButton = styled.div`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
`;

export const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  margin: {
    margin: theme.spacing(1),
  },
  img: {
    width: '100%',
    maxWidth: '300px',
    padding: '2rem',
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '40ch',
  },
  formControl: {
    minWidth: 120,
    flex: 1
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },

  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0',
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF',
    },
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: '400',
      lineHeight: '1',
    },
  },
});

//modal styles
export const stylesModal = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
});

export const DialogTitle = withStyles(stylesModal)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle  className={classes.root} {...other}>
      <Typography variant='h6'>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label='close'
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <RiCloseFill />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
